import { render, staticRenderFns } from "./OccurrenceTeamRequestSummary.vue?vue&type=template&id=2a83b4f9&scoped=true&"
import script from "./OccurrenceTeamRequestSummary.vue?vue&type=script&lang=js&"
export * from "./OccurrenceTeamRequestSummary.vue?vue&type=script&lang=js&"
import style0 from "./OccurrenceTeamRequestSummary.vue?vue&type=style&index=0&id=2a83b4f9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a83b4f9",
  null
  
)

export default component.exports